import React from 'react';
import { withAnimation } from '../AnimatedComponent';

/* @ts-expect-error - TODO: Fix this the next time the file is edited. */
export const Page = ({ children }) =>
  withAnimation(<div className="page-wrapper">{children}</div>);
